import React from "react";
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";

const features = [
  {
    icon: "💰",
    title: "Better Group Discounts",
    text: "A single student has limited bargaining power. By joining a group, members can negotiate significantly lower tuition fees, exclusive scholarships, fee waivers, and additional benefits from coaching institutes.",
  },
  {
    icon: "🏫",
    title: "Compare the Best Institutes",
    text: "Discuss and compare coaching institutes based on faculty, study materials, previous results, hostel facilities, batch timings, placements, and real student experiences before making your decision.",
  },
  {
    icon: "🤝",
    title: "Negotiate Together",
    text: "Every group member can approach institutes and share the offers they receive. Our PriceWorth coordinator also negotiates with reputed institutes to secure exclusive discounts for the entire group.",
  },
  {
    icon: "👨‍💼",
    title: "Dedicated PriceWorth Coordinator",
    text: "Your dedicated coordinator manages negotiations, compares offers from multiple institutes, answers your questions, and helps the group get the best possible value.",
  },
  {
    icon: "🔒",
    title: "Private Group Chat",
    text: "Communicate with fellow students directly on this page without revealing your personal phone number or email address. Your privacy remains protected.",
  },
  {
    icon: "📱",
    title: "Optional WhatsApp Group",
    text: "Students who are comfortable sharing their contact details can join an optional WhatsApp group for quicker communication and discussions.",
  },
];

function GroupInfo() {
  return (
    <Container className="py-5" style={{  }}>
      <div className="text-center mb-5">
        <h2 className="fw-bold mb-3">Why Join This Group?</h2>
        <p
          className="text-muted mx-auto"
          style={{ maxWidth: "720px", fontSize: "1.05rem" }}
        >
          Joining a group gives you more than just discounts. Collaborate with
          like-minded students, compare coaching institutes, negotiate better
          offers together, and make informed decisions with guidance from our
          dedicated PriceWorth coordinator.
        </p>
      </div>

      <Row className="g-4">
        {features.map((item, index) => (
          <Col lg={6} md={6} sm={12} key={index}>
            <Card className="h-100 border-0 shadow-sm rounded-4">
              <CardBody className="p-4">
                <div className="d-flex align-items-start">
                  <div
                    className="me-4 d-flex justify-content-center align-items-center rounded-circle bg-light"
                    style={{
                      width: "60px",
                      height: "60px",
                      fontSize: "1.8rem",
                      flexShrink: 0,
                    }}
                  >
                    {item.icon}
                  </div>

                  <div>
                    <h5 className="fw-bold mb-2">{item.title}</h5>

                    <p
                      className="text-muted mb-0"
                      style={{ lineHeight: "1.7" }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default GroupInfo;